import { route } from "./route";
import { MaterialOptionProps } from "../types/materialLine";
import { MaterialStockEntryType } from "../types/materialStock";

// A material's stock page.
export const stockPath = (materialId: number) =>
  route.materialStockDetail.replace(":id", String(materialId));

// Red below zero, grey at zero, navy above.
export const stockTextClass = (stock: number) =>
  stock < 0 ? "text-red-600" : stock === 0 ? "text-gray-400" : "text-[#113F67]";

// What an entry does to its size's stock.
export const signedQty = (type: MaterialStockEntryType, qty: number) =>
  type === 1 ? -qty : qty;

// A material's bars in stock, over all its sizes: the materials module doesn't show sizes (a new material has the one
// 3660 size), so a material made before that with more sizes shows them added up. Undefined when the stock wasn't sent.
export const totalStock = (sizes: { stock?: number }[]) =>
  sizes.some((size) => size.stock !== undefined)
    ? sizes.reduce((sum, size) => sum + (size.stock ?? 0), 0)
    : undefined;

// A cutting order being edited has already taken its bars out of the stock, so they are free again for it: each
// size's stock plus the bars the order saved of it (a size the save would drop too).
export const withOrderBars = <T extends MaterialOptionProps>(
  materials: T[],
  order:
    | { materials?: { material_size_id: number; qty: number }[] | null }
    | null
    | undefined
): T[] => {
  const saved = new Map<number, number>();

  (order?.materials || []).forEach((row) =>
    saved.set(
      row.material_size_id,
      (saved.get(row.material_size_id) || 0) + (Number(row.qty) || 0)
    )
  );

  if (saved.size === 0) return materials;

  return materials.map((material) => ({
    ...material,
    sizes: material.sizes.map((size) =>
      size.stock === undefined || !saved.has(size.id)
        ? size
        : { ...size, stock: size.stock + (saved.get(size.id) || 0) }
    ),
  }));
};
